
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "banner-button",
  props: {
    widgetClasses: String,
    color: String,        // Puede ser "danger" o "#ad2b2b"
    iconColor: String,
    svgIcon: String,
    title: String,
    description: String,
    target: String
  },

  setup(props) {
    const { t, te } = useI18n();

    const translate = (text: string) => {
      return te(text) ? t(text) : text;
    };

    // Detecta si es un color HEX
    const isHexColor = computed(() => {
      return props.color?.startsWith('#') || false;
    });

    // Clase de fondo
    const bgClass = computed(() => {
      return isHexColor.value ? '' : `bg-${props.color}`;
    });

    // Estilo inline para HEX
    const bgStyle = computed(() => {
      return isHexColor.value ? { backgroundColor: props.color } : {};
    });

    // Clase de texto inverso
    const textClass = computed(() => {
      if (isHexColor.value) {
        return 'text-white'; // o implementa lógica más avanzada
      }
      return `text-inverse-${props.color}`;
    });

    return {
      translate,
      bgClass,
      bgStyle,
      textClass
    };
  }
});
